import { useMutation, useQueryClient } from "react-query";

import { crearImplementa, updateImplementa, deleteImplementa} from '../../services/Implementa';

import { toast } from 'react-hot-toast';
const queryKey = "ticket";

export const useImplementaMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addImplementa = useMutation((body) => crearImplementa(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateImplementaC = useMutation(
    (body) => updateImplementa( body),
    {
      onError: (err) => onError(err),
    }
  );
  const removeImplementa = useMutation((id) => deleteImplementa( id), {
    onSuccess,
    onError,
  });

  return { addImplementa, updateImplementaC, removeImplementa };
};
export default useImplementaMutations;